import { Helmet } from 'react-helmet-async';

import { useLocalStorage } from '@/hooks/useLocalStorage';
import { createElement, Fragment, FunctionComponent, useMemo } from 'react';
import { CreateListOrder } from '../templates/create-list';
import { CreateSimpleOrder } from '../templates/create-simple';

export default function OrderCreatePage() {
  const [selectedScreen] = useLocalStorage<string>({
    key: 'selected-screen',
  });
  const renderOrder = useMemo(() => {
    const render: Record<string, FunctionComponent> = {
      OrderList: CreateListOrder,
      OrderSimple: CreateSimpleOrder,
    };
    return render[selectedScreen ?? 'OrderList'];
  }, [selectedScreen]);
  return (
    <Fragment>
      <Helmet>
        <title> {import.meta.env.VITE_TITLE_BUSINESS}: Crear una nueva orden</title>
      </Helmet>

      {createElement(renderOrder)}
    
    </Fragment>
  );
}
